import React, { useEffect, useRef, useState } from 'react';

const EmailQuestion = ({ question, value = "", onChange }) => {
    const inputRef = useRef(null);
    const [email, setEmail] = useState(value);
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        setEmail(value);
    }, [value]);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setEmail(newValue);
        setIsValid(validateEmail(newValue));
        onChange(newValue);
    };

    return (
        <div className="question text-question mx-0 row align-items-center">
            <div className="chat-label col-lg-5">
                {question.label}
            </div>
            <div className="chat-answer text-center user position-relative col-lg-7 px-0">
                <input
                    ref={inputRef}
                    type="email"
                    value={email}
                    onChange={handleInputChange}
                    placeholder={question.placeholder}
                />
                {!isValid && email && (
                    <small style={{ color: 'red', position: 'absolute', display: 'block' }}>
                        Formato de e-mail inválido!
                    </small>
                )}
            </div>
        </div>
    );
};

export default EmailQuestion;
